import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SessionService, TableConfiguration, TableColumns, HttpService, fileInputParams, MessageService, FunctionsService, FileFormsService, CombosConfiguration, params, LocalStorageService } from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { User } from 'app/models2/administration/user';
import { Memorandum } from 'app/models2/human-resources/memorandum';
import { UpdateData } from 'app/models2/commos/update-data';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { SizePicture } from 'app/models2/commos/size-pircture';
import { BaseResponse } from 'app/models2/commos/base-response';
@Component({
  selector: 'app-memos-detail',
  templateUrl: './memos-detail.component.html',
  styleUrls: ['./memos-detail.component.scss']
})
export class MemosDetailComponent implements OnInit {

  private urlGetDatosUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`
  public urlGetUsuarios: string = `${EndpointDictionary.User.USER_TABLE}`
  private urlGetUsuariosDetalle: string = `${EndpointDictionary.User.CRUD_USER_DATA}`
  private urlPostMemorando: string = `${EndpointDictionary.Memorandum.CRUD_MEMORANDUM_DATA}`

  public nombreSelecionado: string = ''
  public cedula: number
  public usuario: number
  public movil: boolean
  public dataResponsable: User
  private file = null
  private fileForm
  public tipoRedireccion: string
  public imageSrc: string
  public sizePicture: SizePicture

  public companyId = this.storage.get<number>('companyId')
  public fechaLabel: string
  public descripcionLabel: string
  public generadoPorLabel: string
  public nameFile: string = ''
  public anexo

  public FormMemorandos: UntypedFormGroup;
  public firtsForm: UntypedFormGroup;

  //file pdf
  public fileInputMemorandos: fileInputParams = {
    typeFile: "pdf",
    input: "formulario",
    label: "Evidencia en pdf",
    edit: true,
    style: {
      width: '100%'
    }
  }

  //tabla Usuarios
  public configurationUsuarios: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'userId'
  }

  public columnasUsuarios: TableColumns<User>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },

    },
    {
      ID: 'name',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    }
  ]

  public combosConfigResponsable: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlGetDatosUsuarios,
    urlParams: [],
    label: 'Responsable',
  }

  constructor(
    public dialogRef: MatDialogRef<MemosDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private session: SessionService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private formFile: FileFormsService,
    private storage : LocalStorageService
  ) {
    this.FormMemorandos = this.formBuilder.group({
      date: '',
      description: '',
      generatedBy: '',
    });

    this.firtsForm = this.formBuilder.group({
      selection: ''
    })
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando')
    this.tipoRedireccion = this.session.getData('redireccion')
    this.movil = screen.width > 600 ? false : true
    this.FormMemorandos.controls.date.setValue(new Date())

    this.http.getData(`${this.urlGetDatosUsuarios}`).subscribe(
      (res: BaseResponse<User>) => {
        this.dataResponsable = res['body']
      },
      err => console.log(err)
    )

    this.sizePicture = {
      'width': `50%`,
      'margin-top': '5%',
      'border': '1px solid black',
    }

    if (this.tipoRedireccion == 'visualizar') {
      this.inicializarCampos()
    }
    this.message.closeLoading()
  }

  async inicializarCampos() {

    let res:Array<Memorandum> = await this.http.getDataBody(`${this.urlPostMemorando}/${this.data.id}`)
    if (res) {
      this.message.closeLoading()
      var data = res[0]
      this.nombreSelecionado = data.userName
      this.usuario = data.user
      this.descripcionLabel = data.description
      this.fechaLabel = this.functionEter.dateIso(data.date)
      this.generadoPorLabel = data.generatedByName
      this.anexo = `${EndpointDictionary.Base._BASE_URL_V2}${data.memoPdf}/${this.companyId}`
    }

    let img:Array<User> = await this.http.getDataBody(`${this.urlGetUsuariosDetalle}/${data.userId}`)
    if (img) {
      this.message.closeLoading()
      let imgData = img[0].photo
      this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${imgData}/${this.companyId}`
    }

  }

  ValueResponsable($event: User) {
    this.generadoPorLabel = $event.name
    //console.log("valueResponsable", $event)
  }

  seleccionadosUsuarios($event: number) {
    //console.log($event)
  }

  async clickFilaUsuarios($event: User) {

    this.nombreSelecionado = $event.name
    this.cedula = $event.userId
    this.usuario = $event.user
    this.firtsForm.controls.selection.setValue($event.name)
    let res: Array<User> = await this.http.getDataBody(`${this.urlGetUsuariosDetalle}/${$event.userId}`)
    if (res) {
    this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${res[0].photo}/${this.companyId}`}
  }

  saveForm(form: Memorandum) {
    this.FormMemorandos.controls.date.setValue(this.functionEter.dateForm(form.date))
    this.fechaLabel = this.FormMemorandos.controls.date.value
    this.descripcionLabel = this.FormMemorandos.controls.description.value
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos')
  }

  fileSaveMemorandos($event: UpdateData<Memorandum>) {
    this.file = $event.new
    this.nameFile = $event.new.name
    this.fileInputMemorandos.label = $event.new.name
  }

  async save() {
    if (this.file == null) {
      console.log('no se agrego archivo')
      this.fileForm = ''
    } else {
      let formFile: FormData = this.formFile.createMultipartForm(this.file)
      let res: GenericResponse = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formFile)
      this.fileForm = (res)
    }

    let formMemorandum: Memorandum = {
      date: this.FormMemorandos.controls.date.value,
      userId: this.cedula,
      description: this.FormMemorandos.controls.description.value,
      generatedBy: this.FormMemorandos.controls.generatedBy.value,
      memoPdf: this.fileForm,
    }

    this.http.postData(`${this.urlPostMemorando}`, formMemorandum).subscribe(
      (res: BaseResponse<Array<Memorandum>>) => {
        if (res['code'] === 0) {
          this.message.SuccessToast('Memorando creado correctamente')
          this.dialogRef.close()
        } else {
          this.message.Error('Error', 'Error creando memorando')
        }
      }, err => {
        this.message.Error('Error', `${err}`)
      }
    )
  }

  openAnexo() {

    event.preventDefault()

    let ancho: number = 800
    let alto: number = 700
    var x: number = (screen.width / 2) - (ancho / 2);
    var y: number = (screen.height / 2) - (alto / 2);
    window.open(this.anexo, 'popup', 'width=' + ancho + ', height=' + alto + ', left=' + x + ', top=' + y + '')

  }

}
